/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ provider: NonNullable<unknown> }} Audit_Details_Integration_Updated_DescInputs */



/**
* | output |
* | --- |
* | "The {provider} integration's settings were changed for the organisation." |
*
* @param {Audit_Details_Integration_Updated_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_integration_updated_desc = /** @type {((inputs: Audit_Details_Integration_Updated_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Integration_Updated_DescInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Die Einstellungen der Integration ${i?.provider} wurden für die Organisation geändert.`)
	return /** @type {LocalizedString} */ (`The ${i?.provider} integration's settings were changed for the organisation.`)
});